import {styled, Box, Typography} from 'external/material'
import useStudentContext from 'hooks/student'
import DashboardCourse from './DashboardCourse'

import useTranslations from 'hooks/translations'

const StyledDashboardCourses = styled(Box)(dashboardCoursesStyles)

export default function DashboardCourses() {
    const {groups, assignments = {}} = useStudentContext()
    const {translate} = useTranslations()

    return (
        <StyledDashboardCourses>
            <Box className="courses-label">
                <Typography component="span" variant="caption">
                    {translate('my-courses_title')}
                </Typography>
            </Box>
            <Box className="courses-wrapper">
                <Box className="courses-container">
                    {groups.map((group, index) => (<DashboardCourse key={index} {...group} assignment={assignments[group.id]} />))}
                </Box>
            </Box>
        </StyledDashboardCourses>
    )
}



function dashboardCoursesStyles(){

    return {
        display: 'flex',
        flexGrow: 1,
        borderBottom: 0,
        flexShrink: 1,
        flexDirection: 'column',
        overflowY: 'hidden',
        "& .courses-label": {
            display: 'flex',
            padding: 10,
            flexShrink: 0
        },
        "& .courses-wrapper": {
            display: 'flex',
            flexGrow: 1,
            borderBottom: 0,
            flexShrink: 1,
            flexDirection: 'column',
            overflowY: 'hidden',
        },
        "& .courses-container": {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            padding: "0 14px",
            overflowY: 'auto'
        }
    }

}
